module.exports = __webpack_public_path__ + "assets/fonts/Nunito-ExtraBold.ttf";


//////////////////
// WEBPACK FOOTER
// ../assets/fonts/Nunito/Nunito-ExtraBold.ttf
// module id = ../assets/fonts/Nunito/Nunito-ExtraBold.ttf
// module chunks = 0